import { IDataProviderFilter, IPaging, IPagingFromTo } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import settings from 'src/config/settings'

class PartnerScoresItemApi {
  public getPartnerScoresList = async (
    filters: IDataProviderFilter,
    paging: IPaging | IPagingFromTo
  ) => {
    const [accessToken] = getTokens()

    const dataUrl = `${settings.dataServerUrl}/webservice/197/sp/v3/spCS_GetPOEPartnerScoresView/call`
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    const newPaging = paging as IPaging

    const payload = {
      'p.filter': JSON.stringify(filters),
      page: newPaging.page || 1,
      pageSize: newPaging.pageSize || 10,
    }

    const response = await Rest.post({ url: dataUrl, payload, headers }).catch((err) => {
      console.error(err)
    })

    return { Data: response.Rows }
  }
}

export const partnerScoresItemApi = new PartnerScoresItemApi()
